export default "__VITE_ASSET__M9bHu7eN__"